import { LINT_SEVERITY } from 'app/services/formula/ruleLinter';

/**
 * Short pin label shown on the right edge of each finding row, keyed by
 * severity.
 * @type {Object<string, string>}
 */
export const SEVERITY_PIN_LABEL = {
  [LINT_SEVERITY.ERROR]: 'error',
  [LINT_SEVERITY.WARNING]: 'warning',
  [LINT_SEVERITY.INFO]: 'notice',
};

/**
 * Singular/plural summary noun for each severity, keyed by severity.
 * @type {Object<string, { one: string, many: string }>}
 */
export const SEVERITY_SUMMARY_NOUN = {
  [LINT_SEVERITY.ERROR]: { one: 'error', many: 'errors' },
  [LINT_SEVERITY.WARNING]: { one: 'warning', many: 'warnings' },
  [LINT_SEVERITY.INFO]: { one: 'notice', many: 'notices' },
};

/**
 * Severities rendered in the summary bar, in display order.
 * @type {Array<string>}
 */
export const SUMMARY_SEVERITY_ORDER = [
  LINT_SEVERITY.ERROR,
  LINT_SEVERITY.WARNING,
  LINT_SEVERITY.INFO,
];
